if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          $(".product-option").each(function (i, val) {
            var ss = $(val).find('div').text();
            if (ss.indexOf("_collection_title:") > -1) {
              $(val).parents('.cart_wrapper_flex').find('.quantity__button').addClass('disabled');
              $(val).parents('.cart_wrapper_flex').find('.quantity__button').attr('disabled', "disabled");
              $(val).parents('.cart_wrapper_flex').find('.quantity__button.minus').addClass('disabled');
            }
          });

          var comparisonProductsData = this.getAttribute('data-comparison-products');

          if (comparisonProductsData === 'true') {

            // Get all elements on the page
            var allresetsteps = this.querySelectorAll('.resetstep');

            // Loop through each element
            allresetsteps.forEach(function(element) {
                // Remove the inline CSS by setting the style attribute to an empty string
                element.setAttribute('style', '');
            });

            allresetsteps[0].style.display = 'flex';

            // Remove the "highlighted" class from all "comparison-product" elements
            document.querySelectorAll('.product-form').forEach((el) => {
              el.classList.remove('highlighted');
            });

            // uncheck all the radio button ( reset the steps )

            // Get all radio buttons on the page
            var radioButtons = document.querySelectorAll('input[type="radio"]');

            // Iterate through each radio button and uncheck it
            for (var i = 0; i < radioButtons.length; i++) {
              radioButtons[i].checked = false;
            }

            // Select the overlay element
            const overlay = document.querySelector('.comparison-grid-overlay');
            overlay.classList.remove('overlay-active');

            const compareProductGrid = document.querySelector('.product-comparison-grid');
            compareProductGrid.classList.remove('compare-product-grid-active');
          }
        


        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
